import { Login as LoginContainer } from "containers/Login/Login";
import { withAnon } from "lib/hoc/withAnon";

export const Login = withAnon(LoginContainer);
